export const TOXPRINTS_ROUTE_MODES = {
    HOME: 'home',
    REPORT: 'report',
    ASSAYS: 'assays',
    GLOBAL_ASSAYS: 'global-assays',
    ASSAY_DETAIL: 'assay-detail',
};
const getSingleRouteValue = (value) => {
    if (Array.isArray(value)) {
        return typeof value[0] === 'string' ? value[0] : null;
    }
    return typeof value === 'string' ? value : null;
};
const parseView = (value, fallback = 0) => {
    const parsed = Number.parseInt(getSingleRouteValue(value) ?? '', 10);
    return Number.isNaN(parsed) ? fallback : parsed;
};
export function getToxprintsRouteState(route) {
    const path = route?.path || '';
    if (path === '/toxprints/report') {
        return {
            mode: TOXPRINTS_ROUTE_MODES.REPORT,
            reportView: parseView(route?.query?.view),
            assayName: null,
            assaysView: 0,
            category: null,
            label: null,
        };
    }
    if (path === '/toxprints/global_assays') {
        return {
            mode: TOXPRINTS_ROUTE_MODES.GLOBAL_ASSAYS,
            reportView: 0,
            assayName: null,
            assaysView: parseView(route?.query?.view),
            category: getSingleRouteValue(route?.query?.category),
            label: getSingleRouteValue(route?.query?.label),
        };
    }
    if (path === '/toxprints/assays') {
        return {
            mode: TOXPRINTS_ROUTE_MODES.ASSAYS,
            reportView: 0,
            assayName: null,
            assaysView: parseView(route?.query?.view),
            category: getSingleRouteValue(route?.query?.category),
            label: getSingleRouteValue(route?.query?.label),
        };
    }
    if (path.startsWith('/toxprints/assays/')) {
        return {
            mode: TOXPRINTS_ROUTE_MODES.ASSAY_DETAIL,
            reportView: parseView(route?.query?.view),
            assayName: getSingleRouteValue(route?.params?.name),
            assaysView: 0,
            category: null,
            label: null,
        };
    }
    return {
        mode: TOXPRINTS_ROUTE_MODES.HOME,
        reportView: 0,
        assayName: null,
        assaysView: 0,
        category: getSingleRouteValue(route?.query?.category),
        label: getSingleRouteValue(route?.query?.label),
    };
}
